var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 513,
    viewBox: "0 0 512 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2632_3744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.341 122.761L64.5333 58.612L222.443 5.98267C244.331 -1.31333 268.011 -1.31333 289.899 5.98267L448.171 58.74L256.341 122.761ZM188.459 242.719L234.859 165.407L65.344 108.895C52.1813 104.5 37.76 109.855 30.6133 121.737L6.57067 161.844C-7.65866 185.567 3.73333 216.351 29.9733 225.097L138.368 261.236C157.333 267.551 178.176 259.849 188.459 242.719ZM64.1707 58.484V58.7187L64.5333 58.612L64.1707 58.484ZM234.837 510.473V248.329L225.024 264.671C209.195 291.039 181.419 306.164 152.171 306.164C143.104 306.164 133.909 304.735 124.864 301.705L42.8373 274.377V371.615C42.8373 417.524 72.2133 458.292 115.776 472.799L210.389 504.329C218.368 506.911 226.56 509.023 234.837 510.452V510.473ZM506.197 162.548L481.707 121.737C474.581 109.855 460.139 104.5 446.976 108.895L277.483 165.385L323.883 242.697C334.165 259.849 354.987 267.551 373.952 261.215L483.136 224.82C508.971 216.201 520.192 185.887 506.176 162.527L506.197 162.548ZM360.171 306.185C330.923 306.185 303.147 291.081 287.317 264.692L277.504 248.351V510.367C286.507 508.788 295.424 506.484 303.872 503.668H304.085L396.565 472.82C440.128 458.292 469.504 417.545 469.504 371.636V274.377L387.477 301.727C378.432 304.756 369.237 306.185 360.171 306.185Z",
    fill: "#505154"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2632_3744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.002cef76327d826c7d1f6bc656c9a135.svg";
export { ForwardRef as ReactComponent };